module.exports = __webpack_public_path__ + "img/mengtui.c00c186b.png";